





































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
import draggable from 'vuedraggable'
import SearchBar from './components/searchBar.vue'
import Swiper from './components/swiper.vue'
import IntervalSwiper from './components/intervalSwiper.vue'
import Grid from './components/grid.vue'
import HoverGrid from './components/hoverGrid.vue'
import Video from './components/video.vue'
import BlankSpace from './components/blankSpace.vue'
import NoticeBar from './components/noticeBar.vue'
import Products from './components/products.vue'
import Pictures from './components/pictures.vue'
import IntervalPictures from './components/intervalPictures.vue'
import Coupons from './components/coupon.vue'
import Activity from './components/activity.vue'
@Component({
  components: {
    PicModal,
    draggable,
    SearchBar,
    Swiper,
    IntervalSwiper,
    Grid,
    HoverGrid,
    Video,
    BlankSpace,
    NoticeBar,
    Products,
    Pictures,
    IntervalPictures,
    Coupons,
    Activity,
  },
})
export default class HomeSetting extends AbpBase {
  couponList: any[] = []
  goodsList: any[] = []
  isShowStartTime: any = false
  isShowEndTime: any = false
  maxNumberApp: number = 1
  hoverGridIsTop: boolean = false
  initialPosition: number = 0
  MallDiyConfig = {
    isHomePage: false,
    isActive: false,
    name: null,
    startTime: null,
    endTime: null,
    value: {
      Json: {
        Items: [],
      },
    },
  }
  styleData: any = {
    position: 'absolute',
    top: 0,
  }
  // 当前选择的组件
  selectIndex = -1

  showDemoIndex = -1

  selectRightNumber: number = 0

  ruleMallDiy = {
    name: [{ required: true, message: '请输入微页面名称', trigger: 'blur' }],
  }

  // 示例数据
  testList = [
    {
      // 通告栏
      type: 'noticeBar',
      mode: 'link',
      text: '足协杯战线连续第2年上演广州德比战，上赛季半决赛上恒大以两回合5-3的总比分淘汰富力。',
      backgroundColor: '#fffbe8',
      color: '#ed6a0c',
      mesType: 'custom',
      leftIcon: '//img.yzcdn.cn/public_files/2017/8/10/6af5b7168eed548100d9041f07b7c616.png',
      url: 'pages/index/index',
    },
    {
      // 搜索框
      type: 'searchBar',
      placeholder: '请输入商品名称',
      isShowScan: false,
    },
    {
      // 轮播
      type: 'swiper',
      interval: 3000,
      imgUrl: [
        {
          img:
            'http://vicutu-mall.oss-cn-beijing.aliyuncs.com/images/1_15756988978109bcb6cef-4d23-4b95-abcc-cebcaaf011e8.jpg',
          url: '',
        },
        {
          img:
            'http://vicutu-mall.oss-cn-beijing.aliyuncs.com/images/1_1576122522451O1CN011D3mDbx6XcFDkIH_!!1706950161.jpg_430x430q90.jpg',
          url: 'pages/index/index',
        },
        {
          img:
            'http://vicutu-mall.oss-cn-beijing.aliyuncs.com/images/1_1575529792521c45797ee-0ee6-4d28-93fb-07f524884aad.jpg',
          url: '',
        },
      ],
    },
    {
      // 导航图
      type: 'grid',
      columnNum: 4,
      linkType: 'navigateTo',
      items: [
        {
          icon: 'https://mini.gzshb0668.com/Temp/Downloads/0/e179b94e-6b5a-4fea-a9c8-a814d74b68d6.png',
          text: '积分商城',
          url: 'pages/index/index',
        },
        {
          icon: 'https://mini.gzshb0668.com/Temp/Downloads/3/bf8faae3-3a56-4d42-a20a-49ef8611904a.png',
          text: '积分抽奖',
          url: 'pages/index/index',
        },
        {
          icon: 'https://mini.gzshb0668.com/Temp/Downloads/0/f47fcc42-1898-4f3f-821a-4c673532b1f6.png',
          text: '新品上市',
          url: '',
        },
        {
          icon: 'https://mini.gzshb0668.com/Temp/Downloads/0/f47fcc42-1898-4f3f-821a-4c673532b1f6.png',
          text: '签到',
          url: '',
        },
      ],
    },
    {
      // 视频
      type: 'video',
      muted: true,
      poster:
        'http://vicutu-mall.oss-cn-beijing.aliyuncs.com/images/1_15756988978109bcb6cef-4d23-4b95-abcc-cebcaaf011e8.jpg',
      url: 'http://vicutu-mall.oss-cn-beijing.aliyuncs.com/video/mall/_1576552973989%E7%A6%BB%E4%BA%BA%E6%84%81.mp4',
    },
    {
      // 辅助空白
      type: 'blankSpace',
      height: 10,
      color: '#f3f3f3',
    },
    {
      // 商品列表
      type: 'products',
      maxNumber: 6,
      cornerMark: null,
      // 0 选择分类 1 选择具体商品
      selectType: 0,
      // 商品分类Id 优先级高于 商品id数组
      categoryId: null,
      //商品id数组
      list: [],
      //商品展示数组
      products: [],
      title: '商品列表',
      // 0 1 2 三种样式
      styleType: 0,
      // 仅样式三生效
      rowNmuber: 3,
      titleConfig: {
        // text、img
        type: 'text',
        title: '商品列表',
        imgUrl: '',
        style: {
          backgroundColor: '#ffffff',
          color: '#000000',
        },
      },
    },
    {
      // 图片广告
      type: 'pictures',
      styleType: 0,
      imgUrl: [
        {
          img: null,
          url: null,
        },
      ],
    },
    {
      // 优惠券
      type: 'coupon',
      maxNumber: 1,
      isMore: true,
      styleType: 0,
    },
    {
      //活动专区
      type: 'activity',
      // limitDiscount 限时折扣 preSales 预售 group 拼团 secKill 秒杀 buyGetOne 满x件免一 tierDiscount 满减满折 freeShipping 满包邮
      // productPack 商品打包 outfit 套装活动 buyGetGiveaway
      activityType: 'limitDiscount',
      activityId: null,
      activityTitle: null,
      maxNumber: 6,
      cornerMark: null,
      title: '',
      // 0 1 2 三种样式
      styleType: 0,
      // 仅样式三生效
      rowNmuber: 3,
      isMore: true,
      titleConfig: {
        // text、img
        type: 'text',
        title: '',
        imgUrl: '',
        style: {
          backgroundColor: '#ffffff',
          color: '#000000',
        },
      },
    },
  ]

  get selectForm() {
    if (this.selectIndex < 0) {
      return {}
    } else {
      return this.MallDiyConfig.value.Json.Items[this.selectIndex]
    }
  }

  componentList = [
    {
      img: require('@/assets/images/notice.png'),
      label: '通告栏',
      type: 'noticeBar',
    },
    {
      img: require('@/assets/images/search.png'),
      label: '搜索框',
      type: 'searchBar',
    },
    {
      img: require('@/assets/images/banner.png'),
      label: '轮播图',
      type: 'swiper',
    },
    { img: require('@/assets/images/nav.png'), label: '导航图', type: 'grid' },
    // {
    //   img: require('@/assets/images/nav.png'),
    //   label: '悬浮导航图',
    //   type: 'hoverGrid',
    // },
    // {
    //   img: require('@/assets/images/banner.png'),
    //   label: '区间轮播图',
    //   type: 'intervalSwiper',
    // },
    // {
    //   img: require('@/assets/images/rubik.png'),
    //   label: '区间图片广告',
    //   type: 'intervalPictures',
    // },
    {
      img: require('@/assets/images/rubik.png'),
      label: '图片广告',
      type: 'pictures',
    },
    { img: require('@/assets/images/video.png'), label: '视频', type: 'video' },
    {
      img: require('@/assets/images/line.png'),
      label: '辅助空白',
      type: 'blankSpace',
    },
    {
      img: require('@/assets/images/goods.png'),
      label: '商品列表',
      type: 'products',
    },
    // {
    //   img: require('@/assets/images/coupon.png'),
    //   label: '优惠券',
    //   type: 'coupon',
    // },
    {
      img: require('@/assets/images/miaosha.png'),
      label: '活动专区',
      type: 'activity',
    },
  ]

  mounted() {
    this.getConfig()
    this.isShowStartTime = this.$route.query['isHomePage']
    this.isShowEndTime = this.$route.query['isHomePage']
    // 获取指定元素
    // const scrollview: any = this.$refs['scrollview']
    // // 添加滚动监听，该滚动监听了拖拽滚动条
    // // 尾部的 true 最好加上，我这边测试没加 true ，拖拽滚动条无法监听到滚动，加上则可以监听到拖拽滚动条滚动回调
    // scrollview.addEventListener('scroll', this.scrollChange, true)
    // const hoverGridBox: any = this.$refs['hoverGrid']
    // if (hoverGridBox) {
    //   this.initialPosition = hoverGridBox[0].$el.offsetParent.offsetTop
    // }
  }
  handleSelectright(index) {
    this.selectRightNumber = index
  }
  handleSelectGoods(list) {
    this.goodsList = list
  }
  handleSelectrightPic(target) {
    this.MallDiyConfig.value.Json.Items[this.selectIndex].items.forEach((item, index) => {
      if (index == target) {
        item.checked = true
      } else {
        item.checked = false
      }
    })
  }
  scrollChange(e: any) {
    // console.log(e);
    // console.log('父滚动条到页面顶部距离', e.target.scrollTop)
    // 获取指定元素
    const hoverGridBox: any = this.$refs['hoverGrid']
    if (hoverGridBox) {
      let boxOffsetTop = hoverGridBox[0].$el.offsetParent.offsetTop
      if (Number(e.target.scrollTop) - Number(boxOffsetTop) >= 0) {
        console.log('已经到了顶部', e.target.scrollTop)
        this.hoverGridIsTop = true
        // this.styleData.top = e.target.scrollTop + 'px'
      } else {
        this.hoverGridIsTop = false
      }
    }
  }
  /**
   * 获取开启时间
   */
  handleGetstartTime(date) {
    console.log(date)
    this.MallDiyConfig.startTime = date
  }
  handleGetEndTime(date) {
    this.MallDiyConfig.endTime = date
  }
  /**
   * 获取设置
   */
  getConfig() {
    let id = this.$route.query['id']
    if (id) {
      MallConfig.getMallDiy(id.toString()).then((res) => {
        if (res.data) {
          const Items = res.data.value.Json.Items
          res.data.value.Json.Items = this.handleItems(Items)
          console.log(res.data)
          this.MallDiyConfig = res.data
          let obj = res.data.value.Json.Items.find((item1) => {
            return item1.type === 'coupon'
          })
          if (obj) {
            this.couponList = res.data.value.Json.list
            this.maxNumberApp = obj.maxNumber
          }
          let intervalSwiperList = res.data.value.Json.Items.filter((item2) => item2.type == 'intervalSwiper')
          if (intervalSwiperList && intervalSwiperList.length) {
            this.goodsList = this.getNewArray(intervalSwiperList[0].items[0].products, 6)
          }
          let intervalPicList = res.data.value.Json.Items.filter((item3) => item3.type == 'intervalPictures')
          if (intervalPicList && intervalPicList.length) {
            intervalPicList.forEach((item) => {
              item.items.forEach((subItem, subIndex) => {
                if (subIndex == 0) {
                  this.$set(subItem, 'checked', true)
                } else {
                  this.$set(subItem, 'checked', false)
                }
                this.$set(subItem, 'selectIndex', 0)
              })
            })
          }
        }
      })
    }
  }
  getNewArray(array, subGroupLength) {
    let index = 0
    let newArray = []
    while (index < array.length) {
      newArray.push(array.slice(index, (index += subGroupLength)))
    }
    return newArray
  }

  handleItems(Items) {
    // TODO 暂时这样兼容之前的旧数据,全新部署就不用兼容
    return Items.map((item) => {
      // console.log(item)
      if (item.type === 'products' || item.type === 'activity') {
        item.titleConfig = !item.titleConfig
          ? {
              // text、img
              type: 'text',
              title: item.title || '',
              imgUrl: '',
              style: {
                backgroundColor: '#ffffff',
                color: '#000000',
              },
            }
          : item.titleConfig
      }
      if (item.type === 'noticeBar') {
        item.mesType = !item.mesType ? 'custom' : item.mesType
      }
      return item
    })
  }
  numberChange(value) {
    this.maxNumberApp = value
  }
  selectCouponList(value) {
    this.couponList = value
    this.maxNumberApp = value.length
    console.log(this.couponList)
  }
  /**
   * 保存
   */
  submit() {
    let vm = this
    let mallDiyForm: any = vm.$refs.mallDiyForm
    let couponObj = this.MallDiyConfig.value.Json.Items.find((item) => {
      return item.type === 'coupon'
    })
    let intervalSwiperObj = this.MallDiyConfig.value.Json.Items.find((item) => item.type == 'intervalSwiper')
    let intervalPictureObj = this.MallDiyConfig.value.Json.Items.find((item) => item.type == 'intervalPictures')
    console.log(couponObj)
    if (couponObj && this.couponList && !this.couponList.length) {
      this.$Notice.warning({
        desc: '还未选择优惠券',
      })
      return
    }
    console.log(this.couponList, this.maxNumberApp)
    if (this.couponList && this.couponList.length > this.maxNumberApp) {
      this.$Notice.warning({
        desc: '选择的优惠券数量不能大于显示个数',
      })
      return
    }
    if (intervalSwiperObj && intervalSwiperObj.items.length) {
      let isTitle = intervalSwiperObj.items.every((item) => item.title)
      let isProduct = intervalSwiperObj.items.every((item) => item.products.length)
      if (!isTitle) {
        this.$Notice.warning({
          desc: '请输入区间轮播图标题',
        })
        return
      } else if (isTitle && !isProduct) {
        this.$Notice.warning({
          desc: '请选择区间轮播图商品',
        })
        return
      }
    }
    if (intervalPictureObj && intervalPictureObj.items.length) {
      let isTitle = intervalPictureObj.items.every((item) => item.title)
      let tmp = []
      intervalPictureObj.items.forEach((item) => {
        item.items.forEach((item1) => {
          tmp = tmp.concat(item1.imgUrl)
        })
      })
      let isSelectAll = tmp.every((item) => item.img)
      console.log(isSelectAll)
      if (!isTitle) {
        this.$Notice.warning({
          desc: '请输入区间图片广告标题',
        })
        return
      } else if (isTitle && !isSelectAll) {
        this.$Notice.warning({
          desc: '请上传全部的图片广告',
        })
        return
      }
    }
    console.log(this.MallDiyConfig)
    mallDiyForm.validate((valid) => {
      if (valid) {
        if (this.MallDiyConfig.value.Json.Items && this.MallDiyConfig.value.Json.Items.length > 0) {
          let obj = JSON.parse(JSON.stringify(this.MallDiyConfig))
          if (this.couponList) {
            let list = []
            this.couponList.forEach((item) => {
              let itemObj = {
                id: item.id,
                name: item.name,
              }
              list.push(itemObj)
            })
            obj.value.Json.list = list
          }
          console.log(obj)
          // obj.startTime = (obj.startTime)
          MallConfig.createOrUpdateMallDiy(obj).then((res) => {
            if (res.data) {
              const Items = res.data.value.Json.Items
              res.data.value.Json.Items = this.handleItems(Items)
              this.MallDiyConfig = res.data
              // this.MallDiyConfig.time = res.data.startTime
            }
            vm.$Notice.success({
              desc: '提交成功',
            })
          })
        } else {
          this.$Modal.error({
            title: '请选择组件',
          })
        }
      }
    })
  }

  /**
   * 添加组件
   */
  gridClick(item) {
    let obj = {}
    switch (item.type) {
      case 'searchBar':
        obj = {
          type: 'searchBar',
          placeholder: null,
          isShowScan: false,
        }
        break
      case 'swiper':
        obj = {
          type: 'swiper',
          interval: 3000,
          imgUrl: [
            {
              img: null,
              url: null,
            },
          ],
        }
        break
      case 'intervalSwiper':
        obj = {
          type: 'intervalSwiper',
          items: [
            {
              title: null,
              maxNumber: 12,
              products: [],
              list: [],
            },
          ],
        }
        break
      case 'grid':
        obj = {
          type: 'grid',
          columnNum: 4,
          linkType: 'navigateTo',
          items: [
            {
              icon: null,
              text: null,
              url: null,
            },
          ],
        }
        break
      case 'hoverGrid':
        obj = {
          type: 'hoverGrid',
          columnNum: 4,
          linkType: 'navigateTo',
          items: [
            {
              icon: null,
              text: null,
              url: null,
            },
          ],
        }
        break
      case 'video':
        obj = {
          type: 'video',
          muted: true,
          poster: null,
          url: null,
        }
        break
      case 'blankSpace':
        obj = {
          type: 'blankSpace',
          height: 5,
          color: '#f3f3f3',
        }
        break
      case 'noticeBar':
        obj = {
          type: 'noticeBar',
          mode: 'link',
          backgroundColor: '#f67f79',
          color: '#ffffff',
          text: '',
          mesType: 'custom',
          leftIcon: '',
          url: '',
        }
        break
      case 'products':
        obj = {
          type: 'products',
          maxNumber: 6,
          cornerMark: null,
          // 0 选择分类 1 选择具体商品
          selectType: 0,
          // 商品分类Id 优先级高于 商品id数组
          categoryId: null,
          //商品id数组
          list: [],
          //商品展示数组
          products: [],
          title: '商品列表',
          // 0 1 2 三种样式
          styleType: 0,
          // 仅样式三生效
          rowNmuber: 3,
          titleConfig: {
            // text、img
            type: 'text',
            title: '商品列表',
            imgUrl: '',
            style: {
              backgroundColor: '#ffffff',
              color: '#000000',
            },
          },
        }
        break
      case 'pictures':
        obj = {
          type: 'pictures',
          styleType: 0,
          imgUrl: [
            {
              img: null,
              url: null,
              couponId: null
            },
          ],
        }
        break
      case 'intervalPictures':
        obj = {
          type: "intervalPictures",
          bg: null,
          items: [
            {
              items: [
                {
                  imgUrl: [
                    {
                      img: null,
                      url: null,
                    },
                  ],
                  selectIndex: 0,
                  styleType: 0,
                },
              ],
              selectIndex: 0,
              checked: true,
              title: null,
              color: '#000',
            },
          ],
        }
        break
      case 'coupon':
        obj = {
          type: 'coupon',
          maxNumber: 1,
          isMore: true,
          styleType: 0,
        }
        this.couponList = []
        break
      case 'activity':
        obj = {
          type: 'activity',
          // limitDiscount 限时折扣 preSales 预售 group 拼团 secKill 秒杀 buyGetOne 满x件免一 tierDiscount 满减满折 freeShipping 满包邮
          activityType: 'preSales',
          activityId: null,
          activityTitle: null,
          maxNumber: 6,
          cornerMark: null,
          title: '',
          // 0 1 2 三种样式
          styleType: 0,
          // 仅样式三生效
          rowNmuber: 3,
          isMore: true,
          titleConfig: {
            // text、img
            type: 'text',
            title: '',
            imgUrl: '',
            style: {
              backgroundColor: '#ffffff',
              color: '#000000',
            },
          },
        }
        break
    }
    if (obj['type']) {
      if (this.selectIndex > -1) {
        this.MallDiyConfig.value.Json.Items.splice(this.selectIndex + 1, 0, obj)
        this.selectIndex = this.selectIndex + 1
      } else {
        this.MallDiyConfig.value.Json.Items.push(obj)
        this.selectIndex = this.MallDiyConfig.value.Json.Items.length - 1
      }
    }
  }

  /**
   * 选择组件
   */
  selectFn(index) {
    this.selectIndex = index
  }

  /**
   * 删除组件
   */
  deleteItem(index) {
    this.$Modal.confirm({
      title: '提示',
      content: `确定删除该组件?`,
      onOk: () => {
        this.MallDiyConfig.value.Json.Items.splice(index, 1)
        this.selectIndex = -1
      },
    })
  }

  /**
   * 拖拽事件
   */
  draggableChange(e) {
    console.log(e)
  }

  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showDemoIndex = index
  }

  /**
   * 选择背景图
   */
  picChange(e, name) {
    this.MallDiyConfig[name] = e[0].url
  }
}
